import script from "./BaseBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseBanner.vue?vue&type=script&setup=true&lang=js"

import "./BaseBanner.vue?vue&type=style&index=0&id=b5857fbe&lang=css"

const __exports__ = script;

export default __exports__